import { render, staticRenderFns } from "./skus_add.vue?vue&type=template&id=f4e07ab8&scoped=true&"
import script from "./skus_add.vue?vue&type=script&lang=js&"
export * from "./skus_add.vue?vue&type=script&lang=js&"
import style0 from "./skus_add.vue?vue&type=style&index=0&id=f4e07ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e07ab8",
  null
  
)

export default component.exports